export const COLORS = {
  MAIN_COLOR: "linear-gradient(212deg, #3A4CE8 0%, #1F2EB4 98.18%)",
  TEXT_WHITE: "#F9FAFB",
  OPERATOR_MAIN_COLOR: "#F4F5F7",
};

export const PATTERNS = {
  GENERAL_DATE_FORMAT: "DD MMM YYYY",
  DATE_TIME_FORMAT: "DD MMM YYYY, hh.mm a",
  DATE_FORMAT: "MM/DD/YYYY",
  DECIMAL_NUMBER: /^(\d*\.)?\d+$/,
  INPUT_NUMBER: /^[+-]?(\d+([.]\d*)?(e[+-]?\d+)?|[.]\d+(e[+-]?\d+)?)$/,
  EMAIL_PATTERN:
    /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/,
  DOMAIN_PATTERN:
    /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/,
  IP_PATTERN:
    /^([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])$/,
  PASSWORD_PATTERN: /^.{6,}$/,
  PASSWORD_UPPER: /^(?=.*[A-Z]).{1,}$/,
  PASSWORD_LETTER: /^(?=.*[a-zA-Z]).{1,}$/,
  PASSWORD_LOWER: /^(?=.*[a-z]).{1,}$/,
  PASSWORD_NUMBER: /^(?=.*\d).{1,}$/,
  DATE_PATTERN: /^(([01])\d)\/(([012])\d)\/((19|20)\d{2})$/,
  SECTION_PATTERN: /[A-E][1-9]-[1-9]|[A-E][1-9]/g,
  NUMBER_MAX_LENGTH_64: /^[0-9]{,64}$/,
  NUMBER_MAX_LENGTH_128: /^[0-9]{,128}$/,
  NUMBER_MAX_LENGTH_255: /^[0-9]{,255}$/,
  USER_GROUP_NAME: /^[a-zA-Z0-9_ -]*$/,
  BLANK_SPACES: /[^\s*]/g,
  XSS_PATTERN: /^[^<>{}]+$/,
  MAX_LENGTH_5000: /^.{,5000}$/,
  PASSWORD_POLICY:
    /^(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.*[a-z])(?=.*[0-9]).{8,32}$/, // Password must be 8 - 64 characters, include uppercase, lowercase, numeric and  special character'
  USERNAME: /^(?![-])[a-zA-Z0-9-]{6,255}(?<![-])$/g,
  // PHONE_NUMBER: /^(\+|0)[0-9]+$/,
  PHONE_NUMBER: /^\+?[0-9]+$/,
  PHONE_NUMBER_LENGTH: /^\+?[0-9]{6,18}$/,
  PHONE_NUMBER_WITH_LENGTH: /^(\+|0)[0-9]{5,45}$/,
  // ZERO_ONLY: /^((?!(0))\+?[0-9]{6,18})$/,
  ZERO_ONLY: /[^0,\.\s]/,
};

export const NOTE_TYPE = {
  MESSAGE: "MESSAGE",
  CUSTOMER: "CUSTOMER",
};

export const MESSAGE_DATA_TYPE = {
  MEDIA: "MEDIA",
  MESSAGE: "MESSAGE",
  NOTE: "NOTE",
};

export const MESSAGE_DIRECTION_TYPE = {
  OUT: "OUT",
  IN: "IN",
};

export const MESSAGE_TYPE = {
  SMS: "SMS",
  MMS: "MMS",
  WHATSAPP: "WHATSAPP",
  VOICE_MAIL: "VOICE_MAIL",
};

export const CONVERSATION_FILTER_TYPE = {
  AWAITING_REPLIES: "AWAITING_REPLIES",
  MY_REPLIES: "MY_REPLIES",
  ARCHIVED: "ARCHIVED",
  BLOCKED: "BLOCKED",
  ALL: "ALL",
};

export const USER_TYPE = {
  SUPER_ADMIN: "SUPER_ADMIN",
  USER: "USER",
};

export const WORKSPACE_USER_TYPE = {
  ADMIN: "ADMIN",
  OPERATOR: "OPERATOR",
};

export const STATUS_TYPE = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  PENDING: "PENDING",
  DELETE: "DELETE",
};
export const SESSION_TYPE = {
  TWO_FA: "TWO_FA",
  PRIMARY: "PRIMARY",
};

export const SNS_TYPE = {
  GOOGLE: "GOOGLE",
  FACEBOOK: "FACEBOOK",
  APPLE: "APPLE",
  NORMAL: "NORMAL",
};

export const TWO_FACTOR_AUTH = {
  NONE: "NONE",
  SMS: "SMS",
  EMAIL: "EMAIL",
  GOOGLE_AUTH: "GOOGLE_AUTH",
};

export const STORAGE_KEYS = {
  token: "token",
  verifyToken: "verifyToken",
  workspaceId: "workspaceId",
  sessionType: "sessionType",
  user: "user",
  referral: "referral",
  email: "email",
  layout: "layout",
  messageDraft: "messageDraft",
  currentConversationId: "currentConversationId",
  filterStatusConversation: "filterStatusConversation",
};

export const HEADER_TITLE = {
  dashboard: "dashboard",
  userProfile: "userProfile",
  setting: "setting",
  subscription: "subscription",
  noticeBoard: "noticeBoard",
  messageTemplates: "messageTemplates",
  customFields: "customFields",
};

export const OPT_TYPE = {
  OPTED_IN: "OPTED_IN",
  OPTED_OUT: "OPTED_OUT",
};
export const SUPPLIERS = {
  SINCH: "SINCH",
  TWILO: "TWILO",
};

export const ADDRESS_STATUS = {
  ASSIGNED: "ASSIGNED",
  AVAILABLE: "AVAILABLE",
  DELETED: "DELETED",
  DEPLETED: "DEPLETED",
  QUARANTINED: "QUARANTINED",
  RESERVED: "RESERVED",
  RETURNED: "RETURNED",
};

export const INVOICE_STATUS = {
  PENDING: "PENDING",
  PAID: "PAID",
  FAIL: "FAIL",
};

export const CHANNEL_PROVIDER = {
  SMS: "sms",
  MMS: "mms",
  WhatsApp: "whatsapp",
  Voice: "voice",
};

export const CHANNEL_STATUS = {
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
  DELETE: "DELETE",
};

export const CHANNEL_NAME = {
  BULKSMS: "BULKSMS",
};

export const MEDIA_CONTENT_TYPE = {
  IMAGE: "IMAGE",
  FILE: "FILE",
  AUDIO: "AUDIO",
  VIDEO: "VIDEO",
  VOICE_MAIL: "VOICE_MAIL",
};

export const CALL_HISTORY_STATUS = {
  ANSWERED: "ANSWERED",
  DISCONNECT: "DISCONNECT",
};

export const UPLOAD_FILE_TYPE = {
  UPLOAD_VOICE: "UPLOAD_VOICE",
};

export const VOICE_SETTING_OPTIONS = {
  FORWARD_TO_PSTN_NUMBER: "FORWARD_TO_PSTN_NUMBER",
  RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL:
    "RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL",
  DISABLE: "DISABLE",
};

export const OUTGOING_MESSAGE_TYPE = {
  TEXT_TO_SPEECH: "TEXT_TO_SPEECH",
  NONE: "NONE",
  UPLOAD: "UPLOAD",
  RECORD: "RECORD",
};

export const DISPLAY_CALLER_ID_TYPE = {
  CALLER_NUMBER: "CALLER_NUMBER",
  SERVICE_NUMBER: "SERVICE_NUMBER",
};
